import { Typography } from "@mui/material";

import { SvgEnum } from "../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../ui library/HNSColors";
import { getButtonsConfig } from "../config/buttonsConfig";

import GenericModal from "./GenericModal";


export default function WarningModal({ additionalDetails={} }) {

  const BUTTONS = getButtonsConfig(additionalDetails);
  return (
    <GenericModal
      iconName={SvgEnum.HisAlertCircle}
      iconColor={HNSColors.warning[600]}
      iconBgColor={HNSColors.warning[700]}
      title="Warning!"
      titleColor={HNSColors.warning[600]}
      message={<Typography>
              Do you want to continue?
              <span className="text-[12px]" style={{color: HNSColors.failure[500]}}>*Please note: The action cannot be undone.</span>
            </Typography>}
      buttons={[BUTTONS.CANCEL, BUTTONS.CONTINUE]}
    />
  );
}
